<div class="liteconsole-login-auth-container" testId="liteconsole-login-auth-container">
  <section class="auth-entry-surface" testId="liteconsole-login-auth-entry-surface">
    <div class="auth-heading">
      <h3 testId="liteconsole-login-auth-title">{{ 'liteconsole.login-auth.title' | i18n }}</h3>
      <p>{{ 'liteconsole.login-auth.desc' | i18n }}</p>
    </div>
    <form nz-form nzLayout="vertical" [formGroup]="form" class="auth-form" testId="liteconsole-login-auth-form">
      <div class="auth-fields-grid">
        <nz-form-item class="auth-mobile-field">
          <nz-form-label nzRequired>{{ 'liteconsole.login-auth.mobiles' | i18n }}</nz-form-label>
          <nz-form-control>
            <textarea
              nz-input
              [nzAutosize]="{ minRows: 2, maxRows: 4 }"
              formControlName="mobiles"
              [placeholder]="'liteconsole.login-auth.mobiles-placeholder' | i18n"
              testId="liteconsole-login-auth-mobiles-input"
            ></textarea>
          </nz-form-control>
        </nz-form-item>
        <nz-form-item>
          <nz-form-label>{{ 'liteconsole.login-auth.remark' | i18n }}</nz-form-label>
          <nz-form-control>
            <input
              nz-input
              formControlName="remark"
              [placeholder]="'liteconsole.login-auth.remark-placeholder' | i18n"
              testId="liteconsole-login-auth-remark-input"
            />
          </nz-form-control>
        </nz-form-item>
        <div class="auth-submit-row">
          <button
            type="button"
            nz-button
            nzType="primary"
            class="add-auth-button"
            [nzLoading]="saving"
            (click)="save()"
            testId="liteconsole-login-auth-add-button"
          >
            <nz-icon nzType="plus" nzTheme="outline" />{{ 'liteconsole.login-auth.add' | i18n }}
          </button>
        </div>
      </div>
    </form>
  </section>
  <section class="auth-list-surface" testId="liteconsole-login-auth-list-surface">
    <div class="auth-list-header">
      <div class="auth-heading">
        <h3 testId="liteconsole-login-auth-list-title">{{ 'liteconsole.login-auth.list-title' | i18n }}</h3>
        <p>
          <span class="record-count" testId="liteconsole-login-auth-total-count">{{ total }}</span>
          {{ 'liteconsole.login-auth.records' | i18n }}
        </p>
      </div>
      <div class="auth-list-actions">
        <input
          nz-input
          class="auth-search"
          #searchInput
          [placeholder]="'liteconsole.login-auth.search-placeholder' | i18n"
          (keyup.enter)="search(searchInput.value)"
          testId="liteconsole-login-auth-search-input"
        />
        <button nz-button class="secondary-button" (click)="load()" testId="liteconsole-login-auth-refresh-button">
          <nz-icon nzType="reload" nzTheme="outline" />{{ 'common.refresh' | i18n }}
        </button>
      </div>
    </div>
    <div class="auth-list-scroll">
      <nz-table
        #table
        [nzData]="items"
        [nzLoading]="loading"
        [nzFrontPagination]="false"
        nzSize="small"
        testId="liteconsole-login-auth-table"
      >
        <thead>
          <tr>
            <th>{{ 'liteconsole.login-auth.mobile' | i18n }}</th>
            <th>{{ 'liteconsole.login-auth.remark' | i18n }}</th>
            <th>{{ 'common.status' | i18n }}</th>
            <th>{{ 'liteconsole.login-auth.create-time' | i18n }}</th>
            <th>{{ 'common.actions' | i18n }}</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of table.data" [attr.data-testid]="'liteconsole-login-auth-row-' + item.mobile">
            <td>{{ item.countryCode }} {{ item.mobile }}</td>
            <td>{{ item.remark || '-' }}</td>
            <td>
              <nz-tag [nzColor]="item.status === 'Enable' ? 'success' : 'default'">
                {{ (item.status === 'Enable' ? 'liteconsole.login-auth.status.enable' : 'liteconsole.login-auth.status.disable') | i18n }}
              </nz-tag>
            </td>
            <td>{{ item.createTime ? (item.createTime | date: 'yyyy-MM-dd HH:mm') : '-' }}</td>
            <td class="action-cell">
              <nz-switch
                [ngModel]="item.status === 'Enable'"
                [ngModelOptions]="{ standalone: true }"
                (ngModelChange)="setStatus(item, $event)"
                [testId]="'liteconsole-login-auth-status-switch-' + item.mobile"
              />
              <button
                nz-button
                nzType="link"
                nzDanger
                (click)="confirmDelete(item)"
                [testId]="'liteconsole-login-auth-delete-button-' + item.mobile"
              >
                {{ 'common.delete' | i18n }}
              </button>
            </td>
          </tr>
        </tbody>
      </nz-table>
    </div>
    <nz-pagination
      [nzPageIndex]="pageIndex"
      [nzPageSize]="pageSize"
      [nzTotal]="total"
      (nzPageIndexChange)="pageChange($event)"
      testId="liteconsole-login-auth-pagination"
    />
  </section>
</div>
